export default "__VITE_ASSET__CTkQFmQi__"